import styled from 'styled-components';

import FaceDetection from '~components/svgs/FaceDetection';

export const Header = styled.section`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const FaceDetectionSvg = styled(FaceDetection)`
  margin-top: ${({ theme }) => theme.spacing.km16};
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;
